import React from 'react';

const MedicamentsPage = React.lazy(() => import('@apps/Medicaments/components/MedicamentsPage'));

import { IPohodnikRouterItem } from '.';

const medicamentsRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/medicaments',
    component: () => <MedicamentsPage />,
    protected: true,
    title: 'Список медикаментов',
  },
];

export default medicamentsRoutes;
